export function fieldDescription(row: {
  marketplaceRawJson?: unknown;
}): string | null {
  const text = (row.marketplaceRawJson as { source_description?: unknown })
    ?.source_description;
  return typeof text === "string" && text.trim() ? text.trim() : null;
}
